import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { IncidentInsertCommand } from '../../commons/class/incident.class';
import { ENV_TOKEN } from '../../app-module.token';

@Injectable({
  providedIn: 'root',
})
export class GatewayService {
  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;

  private httpService: HttpService = inject(HttpService);
  readonly environment = inject(ENV_TOKEN);

  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }

  /**
   * Inserta una nueva incidencia en el sistema, se construye la ruta para el registro utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio
   * @param request 
   * @returns 
   */
  InsertIncidencia(request: IncidentInsertCommand) {
    // console.log(request)
    const funcion = "icoij/RegisterIncident";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }
}
